import React, { useState, useContext } from 'react'
import { friendlyMessageFor } from '../../../utility/errorHelper'
import { MigrantContext } from '../../../contexts/migrantContext'
import { updateConsumer } from '../../../services/migrantService'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Redirect } from 'react-router-dom'
import { uploadFile } from '../../../services/genericService'
import 'react-phone-number-input/style.css'
import EditProfileForm from './editProfileForm'

function EditProfilePassLogin() {
  const migrantContext = useContext(MigrantContext)
  const [updateSuccesful, setUpdateSuccessful] = useState(false)

  const editProfile = async (
    firstName: string,
    lastName: string,
    phonenumber: string,
    avatar: File | null,
    email: string
  ) => {
    toast.info('Updating profile..', { autoClose: 1000 })

    // Check if there are any changes
    let avatarURL = undefined

    if (
      firstName === migrantContext?.profile?.firstName &&
      lastName === migrantContext?.profile?.lastName &&
      phonenumber === migrantContext?.profile?.phonenumber &&
      email === migrantContext?.profile.email &&
      !avatar
    ) {
      setUpdateSuccessful(true)
    } else {
      // Check if there is avatar
      if (avatar) {
        toast.info('Uploading picture..', { autoClose: 2500 })
        avatarURL = (await uploadFile(avatar, 'avatar')) as string
      }

      updateConsumer(firstName, lastName, avatarURL, phonenumber, email).then(
        newProfile => {
          if (newProfile) {
            toast.success('Profile updated.', { autoClose: 1000 })
            migrantContext?.setProfile(newProfile)
            setUpdateSuccessful(true)
          } else {
            const message = friendlyMessageFor('error')
            toast.warn(message)
          }
        }
      )
    }
  }

  if (updateSuccesful) {
    return <Redirect to="/profile" />
  }

  return (
    <>
      <EditProfileForm
        data-testid="social-login"
        editProfile={(firstName, lastName, phonenumber, avatar, email) => {
          editProfile(firstName, lastName, phonenumber!, avatar!, email!)
        }}
        isSocial={true}
      />
    </>
  )
}

export default EditProfilePassLogin
